import React, { useContext,useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link, NavLink, useLocation } from "react-router-dom";
import Container from "@material-ui/core/Container";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import Box from "@material-ui/core/Box";
import LoginButton from "../../Login/loginButton";
import { WebContext } from "../../../../Utility";
import Search from "../../navbarSearch";
import { NAVBAR_EXTERNAL_LINKS } from "../../../../Constants";
import { DesktopMenuDropdown } from "../mobileNavbar";
const useStyles = makeStyles((theme) => ({
  navbar: {
    height: 80,
    width: "100%",
    zIndex: 1,
     background: "transparent !important",
  },
  navLink: {
    color: theme.agentTheme.card.link_foreground,
    whiteSpace: "nowrap",
    display: "inline-block",
    textDecoration: "none",
    overflow: "hidden",
    verticalAlign: "top",
    webkitPerspective: 600,
    mozPerspective: 600,
    msPerspective: 600,
    perspective: 600,
    webkitPerspectiveOrigin: "50% 50%",
    mozPerspectiveOrigin: "50% 50%",
    msPerspectiveOrigin: "50% 50%",
    perspectiveOrigin: "50% 50%",
    fontSize: "1rem",

    "& span": {
      display: "block",
      position: "relative",
      padding: theme.spacing(1, 3),
      webkitTransition: "all 0.3s ease",
      mozTransition: "all 0.3s ease",
      msTransition: "all 0.3s ease",
      transition: "all 0.3s ease",
      webkitTransformOrigin: "50% 0%",
      mozTransformOrigin: "50% 0%",
      msTransformOrigin: "50% 0%",
      transformOrigin: "50% 0%",
      webkitTransformStyle: "preserve-3d",
      mozTransformStyle: "preserve-3d",
      msTransformStyle: "preserve-3d",
      transformStyle: "preserve-3d",
    },
  },
  navLinkSub: {
    color: "grey",
  },
  navLinkTransparent: {
    "&:hover > span": {
      background: theme.agentTheme.secondary.main,
      color: theme.agentTheme.secondary.foreground,
      webkitTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
      mozTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
      msTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
      transform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
    },

    "& span::after": {
      content: "attr(data-text)",
      webkitFontSmoothing: "antialiased",
      padding: theme.spacing(1, 3),
      color: theme.agentTheme.primary.foreground,
      background: theme.agentTheme.primary.main,
      display: "block",
      position: "absolute",
      left: 0,
      top: 0,
      webkitTransformOrigin: "50% 0%",
      mozTransformOrigin: "50% 0%",
      msTransformOrigin: "50% 0%",
      transformOrigin: "50% 0%",
      webkitTransform: "translate3d(0px, 105%, 0px) rotateX(-90deg)",
      mozTransform: "translate3d(0px, 105%, 0px) rotateX(-90deg)",
      msTransform: "translate3d(0px, 105%, 0px) rotateX(-90deg)",
      transform: "translate3d(0px, 105%, 0px) rotateX(-90deg)",
    },

    "&$activeNavItem": {
      "& span": {
        background: theme.agentTheme.secondary.main,
        color: theme.agentTheme.secondary.foreground,
        webkitTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
        mozTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
        msTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
        transform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
      },
    },
  },
  navLinkNonTransparent: {
    color: theme.agentTheme.primary.foreground,
    "&:hover > span": {
      background: theme.agentTheme.primary.main,
      color: theme.agentTheme.primary.foreground,
      webkitTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
      mozTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
      msTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
      transform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
    },

    "& span::after": {
      content: "attr(data-text)",
      webkitFontSmoothing: "antialiased",
      padding: theme.spacing(1, 3),
      color: theme.agentTheme.secondary.foreground,
      background: theme.agentTheme.secondary.main,
      display: "block",
      position: "absolute",

      left: 0,
      top: 0,
      webkitTransformOrigin: "50% 0%",
      mozTransformOrigin: "50% 0%",
      msTransformOrigin: "50% 0%",
      transformOrigin: "50% 0%",
      webkitTransform: "translate3d(0px, 105%, 0px) rotateX(-90deg)",
      mozTransform: "translate3d(0px, 105%, 0px) rotateX(-90deg)",
      msTransform: "translate3d(0px, 105%, 0px) rotateX(-90deg)",
      transform: "translate3d(0px, 105%, 0px) rotateX(-90deg)",
    },

    "&$activeNavItem": {
      "& span": {
        background: theme.agentTheme.primary.main,
        color: theme.agentTheme.primary.foreground,
        webkitTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
        mozTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
        msTransform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
        transform: "translate3d(0px, 0px, -30px) rotateX(90deg)",
      },
    },
  },
  navBarContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: "inherit",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
    },
  },
  navBarLogo: {
    margin: "auto 0px",
    "& img": {
      width: "100%",
      objectFit: "contain",
    },
    webkitBackdropFilter: "blur(0px)",
    backdropFilter: "blur(0px)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "50%",
    },
  },
  navBarContent: {
    display: "flex",
    flexDirection: "row",
  },
  navBarText: {
    padding: 5,
  },
  navBarTextContainer: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    fontSize: "1.5em",
    margin: theme.spacing(0, 1),
  },
  navIcon: {
    margin: "auto 0px",
  color: theme.agentTheme.primary?.main,
    zIndex: 1,
    webkitBackdropFilter: "blur(0px)",
    backdropFilter: "blur(0px)",
  },
  navIconNonTransparent: {
   color: theme.agentTheme.primary?.main,
  },
  menuDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "rgba(0, 0, 0, 0.9)",
    height: "100vh",
    justifyContent: "space-evenly",
    padding: "100px 0px",
    paddingBottom: "80px",
    position: "absolute",
    width: "100vw",
    left: 0,
    color: "white",
    position: "fixed",
    top: 0,
    bottom: 0,
    zIndex: 99,
  },
  activeNavItem: {
    color: theme.agentTheme.primary.main,
  },
  navbarTransparentBg: {
    background: "transparent",
  },
  navbarColorNonTransparent: {
    backgroundColor: "transparent",
  },
  searchDiv: {
    margin: "auto 8px",
    width: "25%",
    [theme.breakpoints.down("sm")]: {
      width: "40%",
    },
  },
  activeMobileItem: {
    color: theme.agentTheme.primary.main,
  },
  inActiveMobileItem: {
    color: "#ffffff",
  },
  loginButtonTransparent: {
      color: theme.agentTheme.primary.main,
    marginTop: "20px",
    borderColor: theme.agentTheme.primary.main,
  },
  loginButtonNonTransparent: {
    marginTop: "20px",
    color: theme.agentTheme.secondary.main,
    borderColor: theme.agentTheme.secondary.main,
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
}));

export default (props) => {
  let {
    logo_url = "",
    contentArr = [],
    username = "",
    getLogoUrl,
    isMobile = false,
    toggleMenu: mobileNavBarOpen = false,
    memberProfile,
    onNavIconClick,
    nonTransparentNav = false,
     handleCovidMenuClose,
    handleCovidMenuItemClick,
    loginItem,
  } = props || {};
  const classes = useStyles();
  const location = useLocation();
  const { isLoggedIn = false } = useContext(WebContext);
  const { website_modules: websiteModules = {} } = memberProfile || {};
  const { packages: isPackagesEnabled = true } = websiteModules || {};
   const [isLoginMenu, setIsLoginMenu] = useState(false);
       const [anchorEl, setAnchorEl] = useState(null);
         const [clickItem, setClickItem] = useState([]);
   const handleCovidMenuClick = (
      event,
      clickItemParam = [],
      islogin = false
    ) => {
      setIsLoginMenu(islogin);
      if (clickItemParam.length > 0) setClickItem(clickItemParam);
      if (anchorEl == null) setAnchorEl(event.currentTarget);
      else handleCovidMenuClose();
    };
  const getNavItem = () => {
    return (
      <>
        {contentArr.map((item) => {
          let showActive = false;
          if (location.pathname == item.link) showActive = true;
          else if (location.pathname == "/" && item.link == `/${username}`)
            showActive = true;
          else if (item.clickHandle) {
            item.clickItem.map((element) => {
              if (
                element.link == location.pathname ||
                element.link.pathname == location.pathname
              )
                showActive = true;
            });
          }
          if (mobileNavBarOpen) {
          } else {
            if (item.clickHandle) {
              return (
                <>
                  <Box
                    className={classes.navBarTextContainer}
                    position="relative"
                  >
                    <div
                      className={`${classes.navLink} ${nonTransparentNav
                          ? classes.navLinkNonTransparent
                          : classes.navLinkTransparent
                        } ${showActive && classes.activeNavItem}`}
                      onClick={(e) => handleCovidMenuClick(e, item.clickItem)}
                    >
                      <span data-text={item.label}>{item.label}</span>
                    </div>
                  </Box>
                </>
              );
            } else {
              const isExternalLink = NAVBAR_EXTERNAL_LINKS.includes(
                item.label.toLowerCase()
              );
              return (
                <Box
                  className={classes.navBarTextContainer}
                  position="relative"
                >
                  {isExternalLink ? (
                    <a
                      href={item.link}
                      className={`${classes.navLink} ${nonTransparentNav
                          ? classes.navLinkNonTransparent
                          : classes.navLinkTransparent
                        } ${showActive && classes.activeNavItem}`}
                    >
                      <span data-text={item.label}>{item.label}</span>
                    </a>
                  ) : (
                    <NavLink
                      to={{
                        pathname: item.link,
                        hash: item.hash || "",
                        state: { memberProfileData: memberProfile },
                      }}
                      className={`${classes.navLink} ${nonTransparentNav
                          ? classes.navLinkNonTransparent
                          : classes.navLinkTransparent
                        } ${showActive && classes.activeNavItem}`}
                    >
                      <span data-text={item.label}>{item.label}</span>
                    </NavLink>
                  )}
                </Box>
              );
            }
          }
        })}
      </>
    );
  };
  return (
    <div
      className={`${classes.navbar} ${nonTransparentNav
          ? classes.navbarColorNonTransparent
          : classes.navbarTransparentBg
        }`}
    >
      <Container maxWidth={false} className={classes.navBarContainer}>
        <div className={classes.navBarLogo}>
          {!isMobile && logo_url && (
            <Link to={`/${username ? `${username}` : ""}`}>
              <img src={getLogoUrl(logo_url)} height="70" />
            </Link>
          )}
          {isMobile && (
            <div
              className={`${classes.navIcon} ${!mobileNavBarOpen &&
                nonTransparentNav &&
                classes.navIconNonTransparent
                }`}
            >
              {!mobileNavBarOpen ? (
                <MenuIcon onClick={onNavIconClick} />
              ) : (
                <CloseIcon onClick={onNavIconClick} />
              )}
            </div>
          )}
        </div>
        {isMobile && logo_url && (
          <Link to={`/${username ? `${username}` : ""}`}>
            <img src={getLogoUrl(logo_url)} height="70" />
          </Link>
        )}
        {!isMobile && (
          <div className={classes.navBarContent}>{getNavItem()}</div>
        )}
        {!isMobile && (
          <Box
            display={"flex"}
            width={"30%"}
            flexDirection={"row"}
            justifyContent={"flex-end"}
          >
            {isPackagesEnabled && (
              <div className={classes.searchDiv} style={{ width: "100%" }}>
                <Search
                  type="NAVBAR_SEARCH_3"
                  nonTransparentNav={nonTransparentNav}
                />
              </div>
            )}
            <Box
              onClick={(e) => isLoggedIn && handleCovidMenuClick(e, [], true)}
            >
              <LoginButton
                loginClass={
                  nonTransparentNav
                    ? classes.loginButtonNonTransparent
                    : classes.loginButtonTransparent
                }
              />
            </Box>
          </Box>
        )}
        {isMobile && (
          <LoginButton
            loginClass={
              nonTransparentNav
                ? classes.loginButtonNonTransparent
                : classes.loginButtonTransparent
            }
          />
        )}
      </Container>
         {(isLoginMenu || clickItem.length > 0) && (
                          <DesktopMenuDropdown
                            anchorEl={anchorEl}
                            handleCovidMenuClose={handleCovidMenuClose}
                            loginMenu={isLoginMenu}
                            clickItem={isLoginMenu ? loginItem : clickItem}
                            handleCovidMenuItemClick={handleCovidMenuItemClick}
                          />
                        )}
    </div>
  );
};
